import styled from 'styled-components';
import {Space} from "antd";
import {iconColor} from "../../../../../utils/styles";

const StyledMissingErpTabIcon = styled.div`
  align-items: center;
  display: flex;

  &.external-link-icon {
    svg {
      height: 12px;
      width: 12px;
    }
  }

  &:hover {
    ${iconColor(props => props.theme.colors.neutral_9)}
  }

  svg {
    height: 16px;
    width: 16px;

    ${iconColor(props => props.theme.colors.neutral_7)}

    path {
      transition: .2s ease;
    }
  }
`;

const StyledMissingErpTabIconsSpace = styled(Space)`
  & > .ant-space-item {
    align-items: center;
    display: flex;
  }
`;

// Stacks the "Matched" badge and the hover action icons in the same grid cell so the
// actions replace the badge in place on row hover (no gap, no layout shift). The cell
// sizes to whichever child is wider. Opacity swap is driven by tableStyles.cellActionsHover.
const StyledBillMatchedSwap = styled.span`
  align-items: center;
  display: inline-grid;
  justify-items: start;

  & > * {
    grid-area: 1 / 1;
  }
`;

export {
  StyledMissingErpTabIcon,
  StyledMissingErpTabIconsSpace,
  StyledBillMatchedSwap,
}
